import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../../store/store-keys'
import { ICommonDomainComponentsState } from './common-domain-components.reducers'
import clone from 'lodash/clone'
import cloneDeep from 'lodash/cloneDeep'

export const selectCommonDomainComponents =
    createFeatureSelector<Readonly<ICommonDomainComponentsState>>(StoreKeysEnum.CommonDomainComponents)

export const selectAttachmentTypeScanCheckedIds = createSelector(
    selectCommonDomainComponents,
    (data) => clone(data.attachmentTypeScanData.checkedIds)
)

export const selectAttachmentTypeScanCheckedAll = createSelector(
    selectCommonDomainComponents,
    (data) => data.attachmentTypeScanData.checkedAll
)

export const selectAttachmentTypeScanState = createSelector(
    selectCommonDomainComponents,
    (data) => cloneDeep(data.attachmentTypeScanData)
)